export default __webpack_public_path__ + "static/media/leaf4.49249bbe.svg";